// EIP-712: Trendex "Connect" typed data
export function buildConnectTypedData(params: {
  address: `0x${string}`;
  nonce: string;
  chainId: number;
  walletProvider: string;
}) {
  const domain = {
    name: 'Trendex',
    version: '1',
    chainId: params.chainId
  } as const;

  const types = {
    Connect: [
      { name: 'address', type: 'address' },
      { name: 'nonce', type: 'string' },
      { name: 'chainId', type: 'uint256' },
      { name: 'walletProvider', type: 'string' }
    ]
  } as const;

  const message = {
    address: params.address,
    nonce: params.nonce,
    chainId: BigInt(params.chainId),
    walletProvider: params.walletProvider
  } as const;
  return { domain, types, primaryType: 'Connect' as const, message };
}
